import { useState } from 'react';

import type { PageSize } from '@/utils/usePageSize';

const DEFAULT_PAGE_SIZE: PageSize = 10;

// Klijentska (ne server-side) paginacija za in-page pod-liste (stavke cjenika, ugovora, ponude,
// radnog paketa, sati/aktivnosti na tjednom izvještaju i sl.) — namjerna iznimka od GEN-02/GEN-03
// server-side paginacije, isti obrazac kao StatusHistoryTable (vidi CLAUDE.md). Za razliku od
// usePageSize (jedan zajednički localStorage ključ za sve GEN-02/03 liste), pageSize ovdje je
// lokalno stanje po pod-listi — promjena na jednoj embeddanoj listi ne smije promijeniti veličinu
// stranice na nekoj drugoj, nepovezanoj listi negdje drugdje u aplikaciji.
export const useLocalPagination = <T>(items: T[], initialPageSize = DEFAULT_PAGE_SIZE) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSizeState] = useState<PageSize>(initialPageSize);

  const setPageSize = (next: PageSize) => {
    setPageSizeState(next);
    setPage(1);
  };

  const offset = (page - 1) * pageSize;
  const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
  const pageItems = items.slice(offset, offset + pageSize);

  // "offset" — za komponente koje prikazuju redni broj (npr. ActivityLineRow "colIndex"), da
  // numeracija ostane globalna (11, 12, 13...) umjesto da se resetira na svakoj stranici.
  return { page, setPage, pageSize, setPageSize, totalPages, pageItems, offset };
};
